export default function (element, data) {
    let lastScrollTop = 0;
    const header = document.querySelector('.page-header_content');
    
    function handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
      if (window.innerWidth < 560) {
        if (scrollTop > lastScrollTop) {
          // Прокрутка вниз
          header.style.top = "-50px"; // Скрываем шапку
        } else {
          // Прокрутка вверх
          header.style.top = "0"; // Показываем шапку
        }
      } else {
        header.style.top = "0"; // Шапка всегда видна на экранах более 560px
      }
    
      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // Для мобильных браузеров, где значение может быть отрицательным
    }
    
    window.addEventListener("scroll", handleScroll);
}

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary